(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetail', {
            templateUrl: 'app/score-detail/score-detail.component.html',
            controller: ScoreDetailComponent,
            bindings: { data: '<' }
        });

    ScoreDetailComponent.$inject = ['$window'];
    function ScoreDetailComponent($window) {
        var ctrl = this;
        ctrl.goBack = goBack;

        function goBack() {
            $window.history.back();
        }
    }
})();